document.addEventListener("DOMContentLoaded", function () {
  const productGrid = document.querySelector('#ProductGridContainer');
  const pagination = document.querySelector('.pagination');

  if (!productGrid || !pagination) return;

  let nextPageLink = pagination.querySelector('a[rel="next"]');
  let loading = false;

  const loadNextPage = () => {
    if (!nextPageLink || loading) return;
    loading = true;

    fetch(nextPageLink.href)
      .then(res => res.text())
      .then(data => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, 'text/html');

        // Get the new product grid items from the next page
        const newProducts = doc.querySelectorAll('#ProductGridContainer .grid__item');
        const newPagination = doc.querySelector('.pagination a[rel="next"]');

        // Append new products
        newProducts.forEach(item => productGrid.querySelector('.grid').appendChild(item));

        // Update next page link or remove pagination
        if (newPagination) {
          nextPageLink = newPagination;
        } else {
          pagination.remove();
          nextPageLink = null;
        }

        loading = false;
      })
      .catch(err => {
        console.error('Infinite scroll error:', err);
        loading = false;
      });
  };

  // Load when near bottom of the page
  window.addEventListener('scroll', () => {
    if (!nextPageLink || loading) return;

    const scrollPosition = window.scrollY + window.innerHeight;
    const triggerPoint = document.body.offsetHeight - 600;

    if (scrollPosition > triggerPoint) {
      loadNextPage();
    }
  });
});

